// auth.service.ts
import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IAuthWeb } from '../../models/IAuthWeb';
import { LocalStorageService } from '../ecommerce/localstorage.service';
import { jwtDecode } from 'jwt-decode';

interface DecodedToken {
	exp: number; // tiempo de expiración en segundos desde UNIX epoch
	// puedes añadir más campos si tu token tiene más info
}

@Injectable({
	providedIn: 'root'
})
export class AuthWebService {
	private platform = inject(PLATFORM_ID);
	private localStorageService = inject(LocalStorageService);
	constructor(private http: HttpClient) {}

	login(): Observable<{ access_token: string }> {
		return this.http.post<{ access_token: string }>(`${environment.apiWebUrl}/login`, {
			email: environment.authWebUsername,
			password: environment.authWebPassword
		});
	}

	// guardarToken(token: string) {
	// 	localStorage.setItem('jwt_token', token);
	// }

	// obtenerToken(): string | null {
	// 	return localStorage.getItem('jwt_token');
	// }

	// logout() {
	// 	localStorage.removeItem('jwt_token');
	// }

	// Autenticación automática al cargar la web
	authenticate(): Observable<IAuthWeb> {
		const headers = new HttpHeaders({
			Authorization: 'Basic ' + btoa(`${environment.authWebUsername}:${environment.authWebPassword}`)
		});

		return this.http.get<IAuthWeb>(`${environment.apiWebUrl}/login`, { headers });
	}

	// Guardar el token en localStorage
	guardarToken(token: string) {
		if (isPlatformBrowser(this.platform)) {
			localStorage.setItem('jwt_token', token);
		}
	}

	// Recuperar el token de localStorage
	obtenerToken(): string | null {
		if (isPlatformBrowser(this.platform)) {
			return localStorage.getItem('jwt_token');
		} else {
			return null;
		}
	}

	// Eliminar el token de localStorage
	logout() {
		if (isPlatformBrowser(this.platform)) {
			localStorage.removeItem('jwt_token');
		}
	}

	tokenExpirado(): boolean {
		const token = this.obtenerToken();
		if (!token) return true;

		try {
			const decoded = jwtDecode<DecodedToken>(token);
			const ahora = Math.floor(Date.now() / 1000);
			return decoded.exp < ahora;
		} catch {
			return true;
		}
	}

	verificarYRefrescarToken(): Promise<void> {
		return new Promise((resolve, reject) => {
			if (!this.tokenExpirado()) {
				return resolve();
			}

			this.login().subscribe({
				next: (res) => {
					this.guardarToken(res.access_token);
					resolve();
				},
				error: (err) => {
					console.error('No se pudo renovar el token', err);
					this.logout();
					reject(err);
				}
			});
		});
	}
}
